'use client';

import { PropsWithChildren } from 'react';

import Content from './Content';
import Tabs from './Tabs';

const GenericDetailPage = ({ children }: PropsWithChildren) => {
	return <div className="min-h-full flex flex-col">{children}</div>;
};

GenericDetailPage.Content = Content;
GenericDetailPage.Tabs = Tabs;

export default GenericDetailPage;
